import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from "react";
import ClientOnly from "@hl/base-components/lib/ClientOnly";
import { Box } from "@mantine/core";
import ReactTimeAgo from "react-time-ago";
import { reactTimeAgoStyle } from "../../../utils/format";
export const Timer = (props) => {
    const { date, endMessage } = props;
    const [isEnded, setEnded] = useState(+date <= Date.now());
    const onTimesUp = useCallback(() => {
        setEnded(true);
    }, []);
    if (isEnded && endMessage == null) {
        return null;
    }
    return (_jsx(Box, { className: "hl-timer", children: isEnded ? (_jsx("p", { children: endMessage })) : (_jsx(ClientOnly, { placeholder: "...", children: _jsx(ReactTimeAgo, { date: +date, future: true, timeStyle: reactTimeAgoStyle(onTimesUp, 0, true), locale: "en-US" }) })) }));
};
